import type { NewsletterPage } from '@/domains/newsletter/newsletter.types';

const toTitleCase = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

export const formatAuthorName = (value?: string | null) => {
  const identifier = value?.trim();

  if (!identifier) {
    return 'Pegasus Team';
  }

  const localPart = identifier
    .split('@')[0]
    .replace(/#EXT#.*$/i, '')
    .trim();

  const parts = localPart
    .split(/[._-]+/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    return 'Pegasus Team';
  }

  return parts.map(toTitleCase).join(' ');
};

export const getReleaseNoteAuthorName = (
  page: Pick<NewsletterPage, 'createdBy' | 'updatedBy'>,
) => {
  return formatAuthorName(page.createdBy ?? page.updatedBy);
};
